<fieldset class="u-fade-slide-in">
  <h4>{{ 'information_block.header' | translate }}</h4>

  <form [formGroup]="informationForm()">
    @if (contentType() === 'scenic' || contentType() === 'coaching') {
      <div class="selects-containter">
        @if (contentType() === 'coaching') {
          @let languageError =
            informationForm().get('languageId')?.invalid &&
            informationForm().get('languageId')?.touched;
          <app-select-field
            [label]="'information_block.language_placeholder' | translate"
            [filled]="!!informationForm().get('languageId')?.value"
            [errorMessage]="languageError ? ('common.required_field' | translate) : undefined"
          >
            <kin-select
              name="language"
              id="language-select"
              [required]="true"
              [default]="'information_block.language_placeholder' | translate"
              [value]="informationForm().get('languageId')?.value?.toString() || undefined"
              [class.error]="languageError"
              (onSelectedValue)="changeLanguage($event)"
            >
              @for (countrie of this.countryService.countries(); track $index) {
                <option [value]="countrie.id">{{ countrie.name }}</option>
              }
            </kin-select>
          </app-select-field>
        }

        @let vehicules = vehiculeService.shortVehiculesList();
        @if (vehicules.length > 0) {
          @let vehiculeError =
            informationForm().get('vehiculeId')?.invalid &&
            informationForm().get('vehiculeId')?.touched;
          <app-select-field
            [ngStyle]="{
              width: contentType() === 'scenic' ? '50%' : '100%',
              flex: contentType() === 'scenic' ? 'none' : 1,
            }"
            [label]="'information_block.vehicle_placeholder' | translate"
            [filled]="!!informationForm().get('vehiculeId')?.value"
            [errorMessage]="vehiculeError ? ('common.required_field' | translate) : undefined"
          >
            <kin-select
              name="vehicule"
              id="vehicule-select"
              [required]="true"
              [default]="'information_block.vehicle_placeholder' | translate"
              [value]="informationForm().get('vehiculeId')?.value?.toString() || undefined"
              [class.error]="vehiculeError"
              (onSelectedValue)="changeVehicule($event)"
            >
              @for (vehicule of vehicules; track $index) {
                <option [value]="vehicule.id">
                  {{
                    'common.vehicule.' + vehicule.name | lowercase | translate | upperFirstLetter
                  }}
                </option>
              }
            </kin-select>
          </app-select-field>
        }
      </div>
    } @else if (contentType() !== 'workout') {
      <app-select-field
        [ngStyle]="{
          width: contentType() === 'gps-only' ? '50%' : '100%',
          flex: contentType() === 'gps-only' ? 'none' : 1,
        }"
        [label]="'common.sport_placeholder' | translate"
        [filled]="!!informationForm().get('sport')?.value"
      >
        <kin-select
          name="sport"
          id="sport-select"
          [required]="true"
          [default]="'common.sport_placeholder' | translate"
          [value]="informationForm().get('sport')?.value?.toString() || undefined"
          (onSelectedValue)="changeSport($event)"
          [class.error]="
            informationForm().get('sport')?.invalid && informationForm().get('sport')?.touched
          "
        >
          @for (sport of sportTypes; track $index) {
            <option [value]="sport">
              {{ 'common.sport.verb.' + sport | translate | upperFirstLetter }}
            </option>
          }
        </kin-select>
      </app-select-field>
    }
    <span class="divider"></span>
    <div>
      <h3>{{ 'information_block.details.title' | translate }}</h3>
      <p>{{ 'information_block.details.subtitle' | translate }}</p>
    </div>
    <app-input-element
      [inputFormControl]="titleControl"
      inputId="title"
      (valueChange)="onTitleChange($event)"
      [label]="titleLabel | translate"
      [tooltip]="'content_creation.input.title.tooltip' | translate"
      [maxlength]="128"
    />

    @if (contentType() === 'workout' && profileService.isAdmin()) {
      <app-select-field
        [label]="'information_block.theme_placeholder' | translate"
        [filled]="!!informationForm().get('theme')?.value"
        [required]="false"
      >
        <kin-select
          #themeSelect
          name="theme"
          id="theme-select"
          [default]="'information_block.theme_placeholder' | translate"
          [value]="informationForm().get('theme')?.value || undefined"
          (onSelectedValue)="changeTheme($event)"
        >
          <option value="">-</option>
          @for (theme of themesRessources.value() ?? []; track theme) {
            <option [value]="theme">
              {{ 'common.workout_theme.' + theme | translate | upperFirstLetter }}
            </option>
          }
        </kin-select>
      </app-select-field>
    }

    @let descriptionError =
      informationForm().controls['description'].invalid &&
      informationForm().controls['description'].touched;
    @let descriptionErrors = informationForm().controls['description']?.errors;
    @let descriptionMessage =
      descriptionErrors?.['minlength']
        ? ('content_creation.input.description.error.minlength' | translate).replace(
            '{minlength}',
            descriptionErrors?.['minlength'].requiredLength
          )
        : descriptionError && descriptionErrors?.['required']
          ? ('content_creation.input.description.error.required' | translate)
          : undefined;
    <div class="field-group">
      <div
        [ngClass]="{
          'text-area-error': descriptionError,
          touched: descriptionFocused || informationForm().controls['description']?.touched,
        }"
      >
        <quill-editor
          id="description"
          formControlName="description"
          [modules]="editorModules"
          [styles]="{ height: '200px' }"
          [placeholder]="'information_block.details.placeholder' | translate"
        >
        </quill-editor>
      </div>
      @if (descriptionMessage) {
        <p class="field-error">{{ descriptionMessage }}</p>
      }
    </div>

    @if (contentType() !== 'workout') {
      <app-input-element
        [inputFormControl]="recordedWithControl"
        [label]="recordedWithLabel | translate"
        inputId="recordedWith"
        [tooltip]="'content_creation.input.recorded_with.tooltip' | translate"
      />
    }

    <!--? LES TAGS ne sont pas MVP, mais c'est prêt quand même ! -->
    <!-- @if(contentType() === 'scenic' || contentType() === 'workout'){
        <span class="divider"></span>
        <div>
            <h3>Tags</h3>
            <p>Mots clés pour mieux indexer votre vidéo dans le catalogue</p>
        </div>
        <app-tags-element (tagsChanges)="tagsChanges($event)" />
        } -->

    @if (mediaBlockService.gpsHaveAdditionalData()) {
      <span class="divider"></span>
      <app-additional-data />
    }
  </form>
</fieldset>
